module.exports = __webpack_public_path__ + "img/result-simulated.87405273.png";